import { render, staticRenderFns } from "./ParentCategoryForm.vue?vue&type=template&id=90eddec6&"
import script from "./ParentCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ParentCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports